module.exports = __webpack_public_path__ + "static/media/badge_10th.bce42d38.png";